import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ViewportService
{

    constructor() { }

    public scrollIntoView(element: any, offset: number): void
    {
        const { scrollY } = window;
        let top = Math.max(element.getBoundingClientRect().top + scrollY, 0);
        if (top < scrollY || top > (scrollY + window.innerHeight))
        {
            top = Math.max(element.getBoundingClientRect().top + scrollY + offset, 0);
            const animationStep = (value: number) => { window.scroll(0, value); };
            const animator = new Animator(scrollY, top, animationStep);
            animator.start();
        }
    }

    public scrollTo(element: any, offset: number): void
    {
        const { scrollY } = window;
        const top = Math.max(element.getBoundingClientRect().top + scrollY + offset, 0);
        const animationStep = (value: number) => { window.scroll(0, value); };
        const animator = new Animator(scrollY, top, animationStep);
        animator.start();
    }

    public scrollTop(): void
    {
        (new Animator(
            window.pageYOffset,
            0,
            (value: number) => { window.scroll(0, value); }
        )).start();
    }

    public isInViewport(element: any, offset: number): boolean
    {
        const { scrollY } = window;
        const top = Math.max(element.getBoundingClientRect().top + scrollY + offset, 0);
        return !(top < scrollY || top > (scrollY + window.innerHeight));
    }

}

export class Animator
{
    private current: number;
    private from: number;
    private to: number;
    private cancelToken: any;
    private running: boolean;
    private animationStep: (value: number) => void;
    private onDone: () => void;

    public constructor(
        from: number,
        to: number,
        animationStep: (stepValue: number) => void,
        onDone?: () => void
    )
    {
        this.from = from;
        this.to = to;
        this.animationStep = animationStep;
        this.onDone = onDone;
    }

    public start(): void
    {
        if (this.running)
        {
            return;
        }

        const _this = this;
        const from = this.from;
        const to = this.to;
        const animationStep = this.animationStep;
        let current = from;
        this.running = true;

        const animateStep = () =>
        {
            current = current + 0.1 * (to - current);
            _this.current = current;
            animationStep(current);
            if (Math.abs(to - current) > 2)
            {
                _this.cancelToken = requestAnimationFrame(animateStep);
            } else
            {
                _this.running = false;
                if (_this.onDone != null)
                {
                    _this.onDone();
                }
            }
        };

        animateStep();
    }

    public cancel(): void
    {
        cancelAnimationFrame(this.cancelToken);
    }
}
